class CartDrawer {
  constructor() {
    this.el = document.getElementById('cart-drawer');
    this.itemsContainer = document.getElementById('cart-drawer-items');
    this.giftsContainer = document.getElementById('cart-drawer-gifts'); // New Container
    this.giftsItemsContainer = document.getElementById('cart-drawer-gifts-items'); // New Items Wrapper
    this.emptyMessage = document.getElementById('cart-empty-message'); // New Empty State

    this.template = document.getElementById('cart-item-template');
    this.totalPriceEl = document.getElementById('cart-total-price');
    this.isOpen = false;
    this.isUpdating = false;
    this.isMockMode = false;

    // Currency formatter setup
    this.formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    console.log('CartDrawer initialized');
    this.bindEvents();

    // Check for persisted mock cart on load
    this.loadMockCart();
    this.fetchCart(); // Try to fetch real cart too
  }

  bindEvents() {
    // Open cart from header button
    document.querySelectorAll('.header__btn--cart, a[href="/cart"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Si on n'est pas sur une page avec le cart drawer (ex: checkout), rediriger vers home
        if (!this.el) {
          window.location.href = '/?open-cart=1';
          return;
        }
        
        this.open();
      });
    });

    // Vérifier si on doit ouvrir le cart au chargement (depuis redirection)
    if (window.location.search.includes('open-cart=1')) {
      // Nettoyer l'URL
      const url = new URL(window.location);
      url.searchParams.delete('open-cart');
      window.history.replaceState({}, '', url);
      
      // Ouvrir le cart après un petit délai pour laisser le temps au JS de s'initialiser
      setTimeout(() => this.open(), 300);
    }

    // Close triggers
    if (this.el) {
      this.el.querySelectorAll('[data-action="close-cart"]').forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });
      
      this.el.addEventListener('click', (e) => {
        if (e.target === this.el.querySelector('.cart-drawer__overlay')) {
          this.close();
        }
      });

      // --- Event Delegation for Quantity and Remove ---
      this.el.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        
        const action = btn.dataset.action;
        const id = btn.dataset.id;
        
        if (!action || !id) return;

        e.preventDefault(); // Prevent default button behavior
        
        if (action === 'increase') this.changeQuantity(id, 1);
        if (action === 'decrease') this.changeQuantity(id, -1);
        if (action === 'remove') this.changeQuantity(id, -9999);
      });
    }
    
    // Add to cart interception
    document.addEventListener('submit', (e) => {
      const form = e.target;
      const action = form.getAttribute('action');
      
      // On intercepte tout formulaire qui contient "/cart/add"
      if (action && (action.includes('/cart/add') || form.querySelector('[name="add"]'))) {
        e.preventDefault();
        e.stopPropagation();
        
        const formData = new FormData(form);
        const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button[name="add"]');
        
        this.handleAddToCart(formData, submitBtn);
      }
    }, true); // Use capture phase for reliability

    // Checkout interception in Mock Mode
    const checkoutBtn = document.querySelector('.cart-drawer__checkout');
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', (e) => {
            if (this.isMockMode) {
                e.preventDefault();
                alert('Checkout simulé (Mode Démo Local). En production, vous seriez redirigé vers Shopify Checkout.');
            }
        });
    }
  }

  async handleAddToCart(formData, submitBtn) {
    if (this.isUpdating) return;
    this.isUpdating = true;

    let originalText = '';
    if (submitBtn) {
        originalText = submitBtn.textContent;
        submitBtn.textContent = 'Ajout...';
        submitBtn.disabled = true;
    }

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        
        if (!res.ok) {
           console.warn('API Error (expected in local dev). Switching to PERSISTENT MOCK MODE.');
           await this.addMockItem(); 
           return;
        }

        await res.json();
        await this.fetchCart();
        this.open();
        
    } catch (err) {
        console.error('Error adding to cart:', err);
        await this.addMockItem();
    } finally {
        this.isUpdating = false;
        if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
        }
    }
  }

  // --- MOCK LOGIC (LOCAL STORAGE PERSISTENCE) ---

  loadMockCart() {
      const saved = localStorage.getItem('hooq_mock_cart');
      if (saved) {
          try {
              const mockCart = JSON.parse(saved);
              if (mockCart.item_count > 0) {
                  this.isMockMode = true;
                  this.render(mockCart);
                  console.log('Restored Mock Cart from LocalStorage');
              }
          } catch(e) {
              console.error('Error parsing mock cart', e);
          }
      }
  }

  saveMockCart(cart) {
      localStorage.setItem('hooq_mock_cart', JSON.stringify(cart));
  }

  async addMockItem() {
    await new Promise(r => setTimeout(r, 500));
    this.isMockMode = true;
    
    // Retrieve existing mock cart or create new
    let mockCart = {
        item_count: 0,
        total_price: 0,
        items: []
    };
    
    const saved = localStorage.getItem('hooq_mock_cart');
    if (saved) mockCart = JSON.parse(saved);

    // Add item logic
    const newItem = {
        key: 'mock_' + Date.now(),
        product_title: 'Hooq - Pack Starter (Demo)',
        variant_title: 'Noir Mat',
        quantity: 1,
        line_price: 4900,
        // Solid placeholder image
        image: 'https://placehold.co/120x120/1a1a1a/ffffff?text=Hooq+Box'
    };

    mockCart.items.push(newItem);
    this.recalculateMockTotals(mockCart);
    this.saveMockCart(mockCart);
    
    this.render(mockCart);
    this.open();
  }

  recalculateMockTotals(cart) {
      cart.item_count = 0;
      cart.total_price = 0;
      cart.items.forEach(item => {
          cart.item_count += item.quantity;
          cart.total_price += (item.line_price * item.quantity); // simplified logic
      });
  }

  async fetchCart() {
    if (this.isMockMode) return; // Don't fetch real cart if in mock mode

    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();
      
      // Only render real cart if it has items, otherwise mock cart takes precedence if it exists
      if (cart.item_count > 0) {
          this.render(cart);
          // Clear mock if real cart works
          localStorage.removeItem('hooq_mock_cart');
          this.isMockMode = false;
      }
      return cart;
    } catch (err) {
      console.error('Error fetching cart:', err);
    }
  }

  async changeQuantity(id, delta) {
    if (this.isMockMode) {
        this.changeMockQuantity(id, delta);
        return;
    }

    // Retirer TOUT le panier
    if (delta === -9999) {
        await this.clearCart();
        return;
    }

    const item = this.cart.items.find(i => i.key === id || i.variant_id == id);
    if (!item) return; 
    
    const currentTotal = this.cart.item_count;
    let newTotal;
    
    if (delta > 0) {
        // Augmenter : on ajoute simplement au total
        newTotal = currentTotal + delta;
    } else {
        // Diminuer : on veut réduire les PAYANTS de 1, pas juste le total
        // Calcul des payants actuels
        const currentGifts = currentTotal >= 5 ? 2 : currentTotal >= 3 ? 1 : 0;
        const currentPayants = currentTotal - currentGifts;
        const newPayants = Math.max(0, currentPayants - 1);
        
        // Calculer le nouveau total correspondant à (newPayants) payants
        if (newPayants === 0) {
            newTotal = 0;
        } else if (newPayants === 1) {
            newTotal = 1; // 1 payant, 0 offert
        } else if (newPayants === 2) {
            newTotal = 3; // 2 payants + 1 offert (offre 2+1)
        } else {
            // 3+ payants → toujours 2 offerts max
            newTotal = newPayants + 2;
        }
    }
    
    // Mettre à jour la quantité du premier item pour atteindre le nouveau total
    const otherItemsQty = this.cart.items.reduce((sum, i) => i.key === item.key ? sum : sum + i.quantity, 0);
    const newItemQty = Math.max(0, newTotal - otherItemsQty);
    
    this.updateItem(id, newItemQty);
  }

  async clearCart() {
    this.isUpdating = true;
    try {
        const res = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!res.ok) throw new Error('Clear failed');
        
        const cart = await res.json();
        this._lastTotalQty = 0;
        this.render(cart);
    } catch(err) {
        console.error('Error clearing cart:', err);
    } finally {
        this.isUpdating = false;
    }
  }

  changeMockQuantity(id, delta) {
      let mockCart = JSON.parse(localStorage.getItem('hooq_mock_cart'));
      
      // Retirer TOUT le panier
      if (delta === -9999) {
          mockCart.items = [];
          mockCart.item_count = 0;
          mockCart.total_price = 0;
          this._lastTotalQty = 0;
          this.saveMockCart(mockCart);
          this.render(mockCart);
          return;
      }
      
      const itemIndex = mockCart.items.findIndex(i => i.key === id);
      
      if (itemIndex > -1) {
          const currentTotal = mockCart.item_count;
          let newTotal;
          
          if (delta > 0) {
              newTotal = currentTotal + delta;
          } else {
              // Diminuer : on veut réduire les PAYANTS de 1
              const currentGifts = currentTotal >= 5 ? 2 : currentTotal >= 3 ? 1 : 0;
              const currentPayants = currentTotal - currentGifts;
              const newPayants = Math.max(0, currentPayants - 1);
              
              if (newPayants === 0) {
                  newTotal = 0;
              } else if (newPayants === 1) {
                  newTotal = 1;
              } else if (newPayants === 2) {
                  newTotal = 3;
              } else {
                  newTotal = newPayants + 2;
              }
          }
          
          if (newTotal === 0) {
              mockCart.items.splice(itemIndex, 1);
          } else {
              mockCart.items[itemIndex].quantity = newTotal;
          }
          
          this.recalculateMockTotals(mockCart);
          this.saveMockCart(mockCart);
          this.render(mockCart);
      }
  }

  async updateItem(id, quantity) {
    this.isUpdating = true;
    try {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(id), quantity: quantity })
        });
        
        if (!res.ok) throw new Error('Update failed');
        
        const cart = await res.json();
        this.render(cart);
    } catch(err) {
        console.error('Error updating cart:', err);
    } finally {
        this.isUpdating = false;
    }
  }

  render(cart) {
    this.cart = cart;
    
    if (!this.itemsContainer || !this.template) return;

    // Reset Containers
    this.itemsContainer.innerHTML = '';
    this.giftsItemsContainer.innerHTML = '';
    
    // Tracker la quantité précédente pour détecter augmentation/diminution
    const prevQty = this._lastTotalQty || 0;
    const totalQty = cart.item_count;
    this._lastTotalQty = totalQty;
    const isIncreasing = totalQty > prevQty;
    
    if (cart.item_count === 0) {
      this.emptyMessage.style.display = 'block';
      this.giftsContainer.style.display = 'none';
      if (this.totalPriceEl) this.totalPriceEl.textContent = this.formatMoney(0);

      // Update Header with 0
      const countEls = document.querySelectorAll('.header__btn--cart span');
      countEls.forEach(el => el.textContent = this.formatMoney(0));
    } else {
      this.emptyMessage.style.display = 'none';
      
      let virtualGiftsCount = 0;
      
      // LOGIQUE DES OFFRES :
      if (totalQty >= 5) virtualGiftsCount = 2;
      else if (totalQty >= 3) virtualGiftsCount = 1;
      
      let giftsHtml = '';
      let hasGifts = false;
      let displayTotalCents = 0;

      // Render Items
      // On regroupe tous les articles payants en UNE SEULE ligne
      let totalPayantQty = totalQty - virtualGiftsCount;
      let firstItem = cart.items[0]; // On utilise le premier article comme référence
      
      if (firstItem) {
        const image = firstItem.image ? firstItem.image : '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
        
        // 1. Ligne unique pour les articles payants
        if (totalPayantQty > 0) {
            const itemTotalPrice = firstItem.price * totalPayantQty;
            displayTotalCents = itemTotalPrice;

            let html = this.template.innerHTML
              .replace(/{id}/g, firstItem.key)
              .replace(/{title}/g, firstItem.product_title)
              .replace(/{variant}/g, firstItem.variant_title || '')
              .replace(/{quantity}/g, totalPayantQty)
              .replace(/{price}/g, this.formatMoney(itemTotalPrice))
              .replace(/{image}/g, image)
              .replace(/{offer}/g, '');
              
            this.itemsContainer.insertAdjacentHTML('beforeend', html);
        }

        // 2. Section Cadeaux
        let giftCount = virtualGiftsCount;
        if (giftCount > 0) {
            hasGifts = true;
            for (let i = 0; i < giftCount; i++) {
                giftsHtml += `
                    <div class="cart-gift">
                        <div class="cart-gift__image">
                            <img src="${image}" alt="${firstItem.product_title}">
                        </div>
                        <div class="cart-gift__info">
                            <span class="cart-gift__label">Cadeau offert</span>
                            <span class="cart-gift__product">${firstItem.product_title}</span>
                        </div>
                        <span class="cart-gift__badge">OFFERT</span>
                    </div>
                `;
            }
        }
      }

      // MISE À JOUR DES PRIX ET COMPTEURS
      const formattedDisplayTotal = this.formatMoney(displayTotalCents);

      if (this.totalPriceEl) {
          this.totalPriceEl.textContent = formattedDisplayTotal;
      }

      const countEls = document.querySelectorAll('.header__btn--cart span');
      countEls.forEach(el => {
          el.textContent = formattedDisplayTotal;
          el.parentElement.classList.add('pulse');
          setTimeout(() => el.parentElement.classList.remove('pulse'), 500);
      });

      if (hasGifts) {
          this.giftsContainer.style.display = 'block';
          this.giftsItemsContainer.innerHTML = giftsHtml;
      } else {
          this.giftsContainer.style.display = 'none';
          
          if (totalQty === 1) {
              const teaseHtml = `
                <div class="cart-promo-tease">
                    <div class="cart-promo-infos">
                        <span class="cart-promo-text">Plus que <strong>1 Hooq</strong> pour votre cadeau</span>
                        <span class="cart-promo-step">1/2</span>
                    </div>
                    <div class="cart-promo-progress">
                        <div class="cart-promo-fill" style="width: 50%;"></div>
                    </div>
                </div>
              `;
              this.itemsContainer.insertAdjacentHTML('beforeend', teaseHtml);
          } else if (totalQty === 2) {
              const teaseHtml = `
                <div class="cart-promo-tease">
                    <div class="cart-promo-infos">
                        <span class="cart-promo-text">Bravo ! On vous ajoute <strong>1 Hooq</strong> offert...</span>
                        <span class="cart-promo-step">2/2</span>
                    </div>
                    <div class="cart-promo-progress">
                        <div class="cart-promo-fill" style="width: 100%; background: var(--accent);"></div>
                    </div>
                </div>
              `;
              this.itemsContainer.insertAdjacentHTML('beforeend', teaseHtml);
          }
      }

      // AUTO-ADD LOGIQUE SIMPLIFIÉE
      // On ajoute automatiquement SEULEMENT si la quantité AUGMENTE vers 2 ou 4
      if (isIncreasing && (totalQty === 2 || totalQty === 4)) {
          setTimeout(() => {
              if (this.cart && this.cart.items && this.cart.items.length > 0) {
                  const item = this.cart.items[0];
                  this.updateItem(item.key, item.quantity + 1);
              }
          }, 200); // Ultra rapide !
      }
    }
  }

  open() {
    if (this.el) {
        this.el.setAttribute('aria-hidden', 'false');
        this.isOpen = true;
        document.documentElement.classList.add('cart-open');
    }
  }

  close() {
    if (this.el) {
        this.el.setAttribute('aria-hidden', 'true');
        this.isOpen = false;
        document.documentElement.classList.remove('cart-open');
    }
  }

  formatMoney(cents) {
    return this.formatter.format(cents / 100);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});
